export default __webpack_public_path__ + "static/personalized-0a19b2f591650383b9dae801126e191b.svg";